import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import api from '../api/api';
import { getPracticeId } from '../config/practice';
const Settings = ({ setSettingsModal,
  darkMode,
  handleDarkModeChange ,
  threshold,
  fetchSignIndata,
  coloravalaible,
  coloroccupied,
  setColorAvailable,
  setColorOccupied,
  handleColorGet,
  getavailable,
  getoccupied,
  setDarkMode,
  setThreshold,
  fontSize,setFontSize,containerAlignment,setContainerAlignment
}) => {
  // State to manage color and mode settings
  const practiseid = getPracticeId();


  // Handle change for container alignment
  const handleContainerAlignmentChange = async (event) => {
    const newAlignment = event.target.value;
    setContainerAlignment(newAlignment);
    const payload = {
      room_alignment:newAlignment,
    };
    try {
      const response = await api.put(`/v1/${practiseid}/rooms/rooms-color`, payload);
      if (response.status === 200) {
        console.log("Color updated successfully");
        await handleColorGet()
      } else {
        console.error("Failed to update colors");
      }
    } catch (error) {
      console.error("Error updating colors:", error);
    }
  };


const handleFontSizeChange = async(e) => {
  const newFontSize = e.target.value;
    setFontSize(newFontSize); 
  const payload = {
    font_size:newFontSize
  };
  try {
    const response = await api.put(`/v1/${practiseid}/rooms/rooms-color`, payload);
    if (response.status === 200) {
      console.log("Color updated successfully");
      await handleColorGet()
    } else {
      console.error("Failed to update colors");
    }
  } catch (error) {
    console.error("Error updating colors:", error);
  }
};

  const handleCloseSettings = () => {
    setSettingsModal(false);
  };

  const handleColorAvailableChange = async (event) => {
    const newColor = event.target.value;
    setColorAvailable(newColor);
    await handleColorUpdate(newColor, coloroccupied);
    await fetchSignIndata();
    await handleColorGet()
  };

  const handleColorOccupiedChange = async (event) => {
    const newColor = event.target.value;
    setColorOccupied(newColor);
    await handleColorUpdate(coloravalaible, newColor);
    await fetchSignIndata();
    await handleColorGet()
  };

  
 
  const handleColorUpdate = async (availableColor, occupiedColor) => {
    const payload = {
      available_color: availableColor ? availableColor : getavailable,
      occupied_color: occupiedColor ? occupiedColor : getoccupied,
      dark_mode: darkMode ? 'ON' : 'OFF',
      alarm_time:threshold,
    };
    try {
      const response = await api.put(`/v1/${practiseid}/rooms/rooms-color`, payload);
      if (response.status === 200) {
        console.log("Color updated successfully");
      } else {
        console.error("Failed to update colors");
      }
    } catch (error) {
      console.error("Error updating colors:", error);
    }
  };

  const handleThresholdChange = async (e) => {
    const newThreshold = e.target.value === "null" ? null : parseInt(e.target.value);
    setThreshold(newThreshold); // Update the state with the new threshold
    
    // If threshold is updated, make an API call to update the threshold value
    const payload = {
      available_color: coloravalaible ? coloravalaible : getavailable,
      occupied_color: coloroccupied ? coloroccupied : getoccupied,
      dark_mode: darkMode ? 'ON' : 'OFF',
      alarm_time: newThreshold
    };
  
    try {
      const response = await api.put(`/v1/${practiseid}/rooms/rooms-color`, payload);
      if (response.status === 200) {
        console.log("Threshold updated successfully");
      } else {
        console.error("Failed to update threshold");
      }
    } catch (error) {
      console.error("Error updating threshold:", error);
    }
  };
  
  // useEffect(()=>{
  //   handleColorUpdate(coloravalaible,coloroccupied)
  // },[threshold])

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className={`${darkMode ? 'bg-[#333333] text-white' : 'bg-white'}  px-4 pt-3 rounded-md shadow-md w-1/3 font-inter`}>
        <div className="flex justify-between items-center mb-2">
          <div className="text-xl font-inter text-left">Settings</div>
          <div className='flex gap-2'>
         
          <div onClick={handleCloseSettings} className="cursor-pointer">
            <CloseIcon />
          </div>
          </div>
       
        </div>
        <hr className="mb-2" />
        <p className={`text-sm py-0 my-0  ${darkMode ? 'opacity-50' : 'opacity-100'} text-left font-semibold`}>Available Room Color</p>

        <div className={`mb-4 flex mt-1 items-center ${darkMode ? 'opacity-50' : 'opacity-100'} transition-opacity duration-300`}>
        <div
    className="w-6 h-6 rounded-full mr-2"
    style={{ backgroundColor: getavailable }}
  ></div>
          <input
            type="color"
            disabled={darkMode}
            value={coloravalaible || getavailable}
            onChange={handleColorAvailableChange}
            className="border w-[60px] h-[40px] cursor-pointer"
          />
        </div>
        {/* Color Palette */}
        <p className={`text-sm py-0 my-0  ${darkMode ? 'opacity-50' : 'opacity-100'} text-left font-semibold`}>Occupied Room Color</p>

        <div className={`mb-3 flex mt-1 items-center ${darkMode ? 'opacity-50' : 'opacity-100'} transition-opacity duration-300`}>
        <div
    className="w-6 h-6 rounded-full mr-2"
    style={{ backgroundColor: getoccupied }}
      ></div>
          <input
            type="color"
              disabled={darkMode}
            value={coloroccupied || getoccupied}
            onChange={handleColorOccupiedChange}
            className="border w-[60px] h-[40px] cursor-pointer"
          />
        </div>

        {/* Wait Time Dropdown */}
        <div className="mb-3">
  <p className="text-sm py-0 my-0 text-left font-semibold">Patient Wait Time Warning (minutes)</p>
 <input
  type="number"
  value={threshold === null ? "" : threshold} // Handle null case by showing an empty input
  onChange={handleThresholdChange}
  placeholder="Enter Time (mins)"
  className={`border p-2 w-full ${darkMode ? 'bg-[#333333] text-white' : 'bg-white'}`}
/>

</div>


        {/* Dark Mode Dropdown */}
        <div className="mb-1">
          <p className="text-sm py-0 my-0 text-left font-semibold">Dark Mode</p>
          <select
            value={darkMode ? 'true' : 'false'}
            onChange={handleDarkModeChange}
            className={`border p-2 w-full ${darkMode ? 'bg-[#333333] text-white' : 'bg-white'}`}
          >
            <option value="false">OFF</option>
            <option value="true">ON</option>
          </select>
        </div>

        <div className="mb-1 ">
  <p className="text-sm py-0 my-0 text-left font-semibold">Font Size</p>
  <div className="flex flex w-full justify-between px-4">
    <div className="flex flex-col gap-1  items-center justify-center">
      <div>Aa</div>
      <input
        type="radio"
        id="small"
        name="fontSize"
        value="sm"
        checked={fontSize === 'sm'}
        onChange={handleFontSizeChange}
        className="mr-2 cursor-pointer"
      />
      <label htmlFor="small" className="text-xs">Small</label>
    </div>
    <div className="flex flex-col gap-1  items-center justify-center">
    <div className='text-lg'>Aa</div>

      <input
        type="radio"
        id="medium"
        name="fontSize"
        value="md"
        checked={fontSize === 'md'}
        onChange={handleFontSizeChange}
        className="mr-2 cursor-pointer"
      />
      <label htmlFor="medium" className="text-xs">Medium</label>
    </div>
    <div className="flex flex-col gap-1 items-center justify-center">
    <div className='text-xl'>Aa</div>

      <input
        type="radio"
        id="large"
        name="fontSize"
        value="lg"
        checked={fontSize === 'lg'}
        onChange={handleFontSizeChange}
        className="mr-2 cursor-pointer"
      />
      <label htmlFor="large" className="text-xs">Large</label>
    </div>
  </div>
         </div>

         <div className="mb-1">
  <p className="text-sm py-0 my-0 text-left font-semibold">Waiting Room Alignment</p>
  <div className="flex flex w-full justify-around px-4">
    <div className="flex mt-2 flex-col gap-1  items-center justify-center">
      <div className='border-2 flex p-2 rounded-[10px] h-[100px] w-[150px]'>
      <div className='text-xs pt-2 w-[75%]'>Room</div>
      <div className='bg-[#374151] w-[25%] h-full'></div>
      </div>
      <input
            type="radio"
            id="right"
            name="containerAlignment"
            value="right"
            checked={containerAlignment === 'right'}
            onChange={handleContainerAlignmentChange}
            className="mr-2 cursor-pointer"
          />
      <label htmlFor="small" className="text-xs">Right</label>
    </div>
    <div className="flex mt-2 flex-col gap-1  items-center justify-center">
    <div className='border-2 flex flex-col p-2 rounded-[10px] h-[100px] w-[150px]'>
      <div className='text-xs pt-2 w-full h-[65%]'>Room</div>
      <div className='bg-[#374151] w-full h-[35%]'></div>
      </div>
      <input
            type="radio"
            id="bottom"
            name="containerAlignment"
            value="bottom"
            checked={containerAlignment === 'bottom'}
            onChange={handleContainerAlignmentChange}
            className="mr-2 cursor-pointer"
          />
      <label htmlFor="medium" className="text-xs">bottom</label>
    </div>

  </div>
         </div>
      </div>
    </div>
  );
};

export default Settings;
